import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from '@strava/ui/clsx';
import { useFriendsContext } from '../../../state/FriendsContext';
import { INVITE_FRIENDS } from '../../../utils/friendsConstants';

import styles from './FriendList.scss';

const FriendList = ({ children }) => {
  const { state } = useFriendsContext();
  const { followedFriends, onFollowingFriendsChange } = state;

  useEffect(() => {
    onFollowingFriendsChange(followedFriends);
  }, [onFollowingFriendsChange, followedFriends]);

  return (
    <ul
      className={clsx(
        styles.friendList,
        // TODO apply scroll shadow for invite friends after reactified modal is live
        state.source !== INVITE_FRIENDS && styles.scrollShadow
      )}
      data-testid="friend-list"
    >
      {children}
    </ul>
  );
};

FriendList.propTypes = {
  children: PropTypes.node.isRequired
};

export default FriendList;
